import { useEffect, useState } from "react";
import { FormReveal } from "./Animations"
import { LABELS, MESSAGE_DIALOG_FADEOUT, UTILITY_CSS_CLASSES } from "../global/constants";
import { DialogTitle } from "../atoms/DialogTitle";
import { DialogMessage } from "../atoms/DialogMessage";

export const ConfirmDialog = ({
                                show=false, 
                                title=LABELS.confirmDialogTitle,
                                message=LABELS.confirmQuestion, 
                                confirmAction = () => {}, 
                                discardAction = () => {}}
                            ) => {

    const moduleName = 'dialog';
    const modifier = 'dialog--confirm'
    const [showClass, setShowClass] = useState('');
    
    useEffect(() => {
        if ( show ) {
            setShowClass(UTILITY_CSS_CLASSES.show);
        } else {
            setShowClass('');
        }
    }, [show]);

    if ( !show ) {
        return '';
    }

    return (
        
        <FormReveal className={`modal`} key={0}>
            <div className={`${moduleName} ${modifier} ${showClass}`}>
                <DialogTitle text={title}/>
                <DialogMessage text={message} />

                <div className={ `${moduleName}__btns-wrapper` }>
                    <button className="btn btn--molding" onClick={discardAction}>{LABELS.cancel}</button>
                    <button className="btn btn--molding" onClick={confirmAction}>{LABELS.confirm}</button>
                </div>
            </div>
        </FormReveal> 
    )
}

export const MessageDialog  = ({
                                title=LABELS.message,
                                message=LABELS.messageDialogMessage, 
                            }) => {

    const moduleName = 'dialog';
    const modifier = 'dialog--message'
    const [showClass, setShowClass] = useState(UTILITY_CSS_CLASSES.show);
    const [hideDialog, setHideDialog] = useState(false);

    const discardDialog = () => {
        setHideDialog(true);
        setShowClass('');
    }


    if ( hideDialog ) {
        return '';
    }

    const renderContent = () => {
        return (
            <div className={`${moduleName} ${modifier} ${showClass}`}>
                <DialogTitle text={title}/>
                <DialogMessage text={message} />    

                { 
                    <div className={ `${moduleName}__btns-wrapper` }>
                        <button className="btn btn--molding" onClick={discardDialog}>{LABELS.dismiss}</button>
                    </div>
                }
            </div>
        );
    }

   
    return (
        <FormReveal className={`modal`} key={0} replay={hideDialog} reverse={hideDialog}>
            { renderContent() }
        </FormReveal>
    )
}
